"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var CBOR = require("@wireapp/cbor");
var ClassUtil_1 = require("../util/ClassUtil");
var IdentityKey_1 = require("./IdentityKey");
var KeyPair_1 = require("./KeyPair");
var SecretKey_1 = require("./SecretKey");
var IdentityKeyPair = (function () {
    function IdentityKeyPair() {
        this.public_key = new IdentityKey_1.default();
        this.secret_key = new SecretKey_1.default();
        this.version = -1;
    }
    IdentityKeyPair.new = function () {
        return __awaiter(this, void 0, void 0, function () {
            var key_pair, ikp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, KeyPair_1.default.new()];
                    case 1:
                        key_pair = _a.sent();
                        ikp = ClassUtil_1.default.new_instance(IdentityKeyPair);
                        ikp.version = 1;
                        ikp.secret_key = key_pair.secret_key;
                        ikp.public_key = IdentityKey_1.default.new(key_pair.public_key);
                        return [2, ikp];
                }
            });
        });
    };
    IdentityKeyPair.prototype.serialise = function () {
        var encoder = new CBOR.Encoder();
        this.encode(encoder);
        return encoder.get_buffer();
    };
    IdentityKeyPair.deserialise = function (buf) {
        var decoder = new CBOR.Decoder(buf);
        return IdentityKeyPair.decode(decoder);
    };
    IdentityKeyPair.prototype.encode = function (encoder) {
        encoder.object(3);
        encoder.u8(0);
        encoder.u8(this.version);
        encoder.u8(1);
        this.secret_key.encode(encoder);
        encoder.u8(2);
        return this.public_key.encode(encoder);
    };
    IdentityKeyPair.decode = function (decoder) {
        var self = ClassUtil_1.default.new_instance(IdentityKeyPair);
        var nprops = decoder.object();
        for (var index = 0; index <= nprops - 1; index++) {
            switch (decoder.u8()) {
                case 0:
                    self.version = decoder.u8();
                    break;
                case 1:
                    self.secret_key = SecretKey_1.default.decode(decoder);
                    break;
                case 2:
                    self.public_key = IdentityKey_1.default.decode(decoder);
                    break;
                default:
                    decoder.skip();
            }
        }
        return self;
    };
    return IdentityKeyPair;
}());
exports.default = IdentityKeyPair;
//# sourceMappingURL=IdentityKeyPair.js.map


//////////////////
// WEBPACK FOOTER
// ../proteus/dist/keys/IdentityKeyPair.js
// module id = 64
// module chunks = 0 1